module.exports = __webpack_public_path__ + "static/media/inspiration.a3f8e139.svg";